import Panel from '../panel'
import Visibility from './Visibility'
import Indicator from './Indicator'
import InputGroup from '../ui-components/InputGroup'

const ConfigurationPanel = (props) => {
  let { defaultMessage, successMessage, visibility, indicator, indicatorLabel } = props.configuration
  return (
    <Panel title={'Configuration'}>
      <div className={'row'}>
        <InputGroup
          title={'Default message'}
          meta={'The message users get to see when they did not vote yet'}
          type={'text'}
          onChange={(e) => props.setValue(e.target.value, 'defaultMessage')}
          value={defaultMessage} />
        <InputGroup
          title={'Thank you message'}
          meta={'The message users get to see after they voted'}
          type={'text'}
          onChange={(e) => props.setValue(e.target.value, 'successMessage')}
          value={successMessage} />
      </div>
      <Indicator status={indicator}
        setIndicator={props.setIndicator}
        indicatorLabel={indicatorLabel}
        setIndicatorLabel={props.updatePhrase}
      />
      <Visibility visibility={visibility}
        onChange={(visibility) => props.setVisibility(visibility)} />
    </Panel>
  )
}

export default ConfigurationPanel
